module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"booked":"已报名","follow":"仅关注","detail":"详情","teaching":"执教"},"TW":{"booked":"已報名","follow":"僅關注","detail":"詳情","teaching":"執教"},"en":{"booked":"Booked ","follow":"Followed","detail":"Detail","teaching":"Teaching"}}')
  delete Component.options._Ctor
}
